<template>
  <div class="detail" id="gp-`detail`">
    <!-- 单视频模板 -->
    <div v-if="this.gameDetailData.type == 1" class="detail-wrap-1">
      <div class="game__header">
        <div class="dot-overlay"></div>
        <div class="game__header__image" :style="'background-image: url(' + this.gameDetailData.headImg + ');'"></div>

        <div class="game__header__sizzler">
          <video muted="" autoplay="" loop="" id="game__trailer" class="game__preview__trailer"
            :src="this.gameDetailData.headVideo" v-if="this.gameDetailData.videoLink != '#'"></video>
          <div v-else class="game__header__sizzler_bg"
            :style="'background-image: url(' + this.gameDetailData.headVideo + ');'"></div>
        </div>
        <img :src="this.gameDetailData.logoUrl" class="game__logo desktop" />

        <div class="game__cta desktop">
          <div v-if="this.gameDetailData.videoLink != '#'" class="game__cta__button">
            <a @click="showGameVideoModal()" class="button button-text button--transparent">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label"><span>{{ $t(`ButtonText.WATCHTRAILER`) }}</span></div>
            </a>
          </div>
          <div class="game__cta__button">
            <a class="button button-text button--transparent" @click="showGameDetailModal()">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label"><span>{{ $t(`ButtonText.LEARNMORE`) }}</span></div>
            </a>
          </div>
          <div class="game__cta__button">
            <a v-if="this.gameDetailData.buyLink != '#'" :href="this.gameDetailData.buyLink" target="bugGame"
              class="button button-text button--red button--transparent">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label button__label--default">
                <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
              </div>
              <div class="button__label button__label--hover">
                <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
              </div>
            </a>
          </div>
          <div class="game__cta__button game__cta__button--official-site">
            <a :href="this.gameDetailData.officialSiteLink" target="officialSiteLink">{{ $t(`ButtonText.OFFICIALSITE`) }}</a>
          </div>
        </div>
        <div class="game-mobile__info mobile">
          <img :src="this.gameDetailData.logoUrl" class="game-mobile__logo" />
          <div class="game-mobile__links-container">
            <div class="game-mobile__links">
              <div class="game-mobile__link">
                <a class="button button-text button--transparent button--block" @click="showGameDetailModal()">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.LEARNMORE`) }}</span></div>
                </a>
              </div>
              <div v-if="this.gameDetailData.videoLink != '#'" class="game-mobile__link">
                <a class="button button-text button--transparent button--block" @click="showGameVideoModal()">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.WATCHTRAILER`) }}</span></div>
                </a>
              </div>
              <div class="game-mobile__link">
                <a :href="this.gameDetailData.officialSiteLink"
                  class="button button-text button--transparent button--block" target="officialSiteLink">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.OFFICIALSITE`) }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <a v-if="this.gameDetailData.buyLink != '#'" class="game-mobile__cta" :href="this.gameDetailData.buyLink"
            target="bugGame">{{ $t(`ButtonText.BUYNOW`)}}</a>
        </div>
        <div class="game__tile-shadow"></div>
      </div>
    </div>
    <!-- 多图模板 -->
    <div v-else-if="this.gameDetailData.type === 2" class="detail-wrap-2">
      <div class="game__header">
        <div class="dot-overlay"></div>
        <div class="game__header__image" :style="'background-image: url(' + this.gameDetailData.headImg + ');'"></div>
        <div class="game__header__sizzler">
          <video muted="" autoplay="" loop="" id="game__trailer" class="game__preview__trailer"
            :src="this.gameDetailData.headVideo" v-if="this.gameDetailData.videoLink != '#'"></video>
          <div v-else class="game__header__sizzler_bg"
            :style="'background-image: url(' + this.gameDetailData.headVideo + ');'"></div>
        </div>
        <img :src="this.gameDetailData.logoUrl" class="game__logo desktop" />

        <div class="game__cta desktop">
          <div v-if="this.gameDetailData.videoLink != '#'" class="game__cta__button">
            <a @click="showGameVideoModal()" class="button button-text button--transparent">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label"><span>{{ $t(`ButtonText.WATCHTRAILER`) }}</span></div>
            </a>
          </div>
          <div class="game__cta__button">
            <a class="button button-text button--transparent" @click="showGameDetailModal()">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label"><span>{{ $t(`ButtonText.LEARNMORE`) }}</span></div>
            </a>
          </div>
          <div class="game__cta__button">
            <a v-if="this.gameDetailData.buyLink != '#'" :href="this.gameDetailData.buyLink" target="bugGame"
              class="button button-text button--red button--transparent">
              <div class="button__background"></div>
              <div class="button__slide-in"></div>
              <div class="button__label button__label--default">
                <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
              </div>
              <div class="button__label button__label--hover">
                <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
              </div>
            </a>
          </div>
          <div class="game__cta__button game__cta__button--official-site">
            <a :href="this.gameDetailData.officialSiteLink" target="officialSiteLink">{{ $t(`ButtonText.OFFICIALSITE`) }}</a>
          </div>
        </div>
        <div class="game-mobile__info mobile">
          <img :src="this.gameDetailData.logoUrl" class="game-mobile__logo" />
          <div class="game-mobile__links-container">
            <div class="game-mobile__links">
              <div class="game-mobile__link">
                <a class="button button-text button--transparent button--block" @click="showGameDetailModal()">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.LEARNMORE`) }}</span></div>
                </a>
              </div>
              <div v-if="this.gameDetailData.videoLink != '#'" class="game-mobile__link">
                <a class="button button-text button--transparent button--block" @click="showGameVideoModal()">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.WATCHTRAILER`) }}</span></div>
                </a>
              </div>
              <div class="game-mobile__link">
                <a :href="this.gameDetailData.officialSiteLink"
                  class="button button-text button--transparent button--block" target="officialSiteLink">
                  <div class="button__background"></div>
                  <div class="button__slide-in"></div>
                  <div class="button__label"><span>{{ $t(`ButtonText.OFFICIALSITE`) }}</span></div>
                </a>
              </div>
            </div>
          </div>
          <a v-if="this.gameDetailData.buyLink != '#'" class="game-mobile__cta" :href="this.gameDetailData.buyLink"
            target="bugGame">{{ $t(`ButtonText.BUYNOW`)}}</a>
        </div>
        <div class="game__tile-shadow"></div>
      </div>
      <div class="game__body">
        <div class="featured__layout  no-social-widget ">
          <div class="featured__layout-spacer desktop"></div>
          <div :class="'featured__layout--' + this.gameDetailData.blockNum">
            <div class="featured__media featured__media--video item tile" v-for="(item, i) in gameDetailData.src"
              :key="gameDetailData.src[i].index" @click="openOutLink(item.vidioUrl)">
              <div class="featured__media--play-btn btn--hover"></div>
              <div class="featured__media--play-btn btn--non-hover"></div>
              <div class="tile__text">
                <h3 class="featured__media--display-title" v-html="item.title"></h3>
              </div>
              <div class="featured__media--inner tile__bg" :style="'background-image: url(' + item.imgUrl + ');'"></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- modal -->
    <!-- {{ $t(`ButtonText.LEARNMORE`) }} -->
    <div class="gp-modal" v-show="flag_modal">
      <a class="modal__close" @click="closeGameDetailModal()">
        <div class="close__sprite"></div>
      </a>
      <div class="content__row content__row--game-modal">
        <div class="game__modal__text">
          <div>
            <div class="game__modal__fob">
              <img :src="this.gameDetailData.detailImg">
            </div>
            <div class="game__modal__text-description">
              <img :src="this.gameDetailData.logoUrl">
              <div class="content__wysiwyg">
                <p v-html="this.gameDetailData.gameIntro"></p>
              </div>
              <div class="game__modal__text-stats">
                <div class="content__row--game-modal mobile">
                  <div class="game__stat">
                    <div class="game__mobile__info">
                      <h5 class="stat__title">{{ $t(`Detail.GAMENAME`) }}</h5>
                      <p>{{ this.gameDetailData.gameName }}</p>
                      <div class="margin-b-1"></div>
                      <h5 class="stat__title">{{ $t(`Detail.DEVELOPER`) }}</h5>
                      <p>{{ this.gameDetailData.gameDeveloper }}</p>
                    </div>
                    <div class="margin-b-1"></div>
                    <div class="game__mobile__info release-dates">

                      <h5 class="stat__title">{{ $t(`Detail.PLATFORM`) }}</h5>
                      <p v-html="this.gameDetailData.gamePlatform"></p>
                      <p v-html="this.gameDetailData.copyright"></p>
                    </div>
                  </div>
                  <div class="game__stat text-align-r">
                    <div class="game__mobile__info game__mobile__info--right mobile">
                      <div class="stat__title margin-t-1">
                        <a target="officialSiteLink" :href="this.gameDetailData.officialSiteLink"
                          class="game__modal__link">
                          <h5>{{ $t(`ButtonText.OFFICIALSITE`) }}</h5>
                        </a>
                      </div>
                      <a v-if="this.gameDetailData.buyLink != '#'"
                        class="game__modal__cta-btn button button-text button--red" :href="this.gameDetailData.buyLink"
                        target="bugGame">
                        <div class="button__background"></div>
                        <div class="button__slide-in"></div>
                        <div class="button__label button__label--default">
                          <span> {{ $t(`ButtonText.BUYNOW`)}} </span>
                        </div>
                        <div class="button__label button__label--hover">
                          <span> {{ $t(`ButtonText.BUYNOW`)}} </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="content__row--game-modal desktop">
                  <div class="game__stat">
                    <div>
                      <h5 class="stat__title">{{ $t(`Detail.GAMENAME`) }}</h5>
                      <p>{{ this.gameDetailData.gameName }}</p>
                      <h5 class="stat__title">{{ $t(`Detail.DEVELOPER`) }}</h5>
                      <p>{{ this.gameDetailData.gameDeveloper }}</p>
                    </div>
                  </div>
                  <div class="game__stat">
                    <div class="release-dates">
                      <h5 class="stat__title">{{ $t(`Detail.PLATFORM`) }}</h5>
                      <p v-html="this.gameDetailData.gamePlatform"></p>
                      <p v-html="this.gameDetailData.copyright"></p>
                    </div>
                  </div>
                  <div class="game__stat">
                    <div class="stat__title">
                      <a target="officialSiteLink" :href="this.gameDetailData.officialSiteLink" class="game__modal__link">
                        <h5 class="inline-block">{{ $t(`ButtonText.OFFICIALSITE`) }}</h5>
                      </a>
                    </div>
                    <a v-if="this.gameDetailData.buyLink != '#'" class="game__modal__cta-btn button button-text button--red"
                      :href="this.gameDetailData.buyLink" target="bugGame">
                      <div class="button__background"></div>
                      <div class="button__slide-in"></div>
                      <div class="button__label button__label--default">
                        <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
                      </div>
                      <div class="button__label button__label--hover">
                        <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="game__modal__image" style="background-image: url()"></div>
      </div>
    </div>
    <!-- 游戏视频 -->
    <div class="gp-modal" v-show="flag_modal_video">
      <a class="modal__close" @click="closeGameVideoModal()">
        <div class="close__sprite"></div>
      </a>
      <div class="content__row content__row--game-modal" id="game_video_wrap">
        <iframe id="iframe_game_video" :src='this.current_game_vidio' scrolling="no" border="0" frameborder="no"
          framespacing="0" allowfullscreen="true" width="100vw" height='100vh'> </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  gameDetails, gameDetails_En
} from "../common/js/gamesData.js";
export default {
  name: "detail",
  data() {
    return {
      flag_modal: false,
      flag_modal_video: false,
      current_game_vidio: "",
      gameDetailData: {},
      language: 'chinese'
    };
  },
  computed: {
    locale:function(){
      return this.$i18n.locale;
    },
  },
  components: {},
  mounted() {
    
    // if (this.$i18n.locale=='zh') this.gameDetailData = gameDetails[this.$route.query.id - 1]
    // else this.gameDetailData = gameDetails_En[this.$route.query.id - 1]
    
    this.gameDetailData=this.$i18n.t(`Detail.gameDetail`)[this.$route.query.id]
    console.log(this.$i18n.t(`Detail.gameDetail`),this.gameDetailData)
  },
  methods: {
    showGameDetailModal() {
    //   if (this.$i18n.locale=='zh') this.gameDetailData = gameDetails[this.$route.query.id - 1]
    // else this.gameDetailData = gameDetails_En[this.$route.query.id - 1]
    this.gameDetailData=this.$i18n.t(`Detail.gameDetail`)[this.$route.query.id]
      this.flag_modal = true;
      document.body.classList.add('body-hidden');
      document.getElementById("gp-detail").style.zIndex = 101;
    },
    closeGameDetailModal() {
      this.flag_modal = false;
      document.body.classList.remove('body-hidden');
      document.getElementById("gp-detail").style.zIndex = 99;
    },
    showGameVideoModal() {
      this.flag_modal_video = true;
      this.current_game_vidio = this.gameDetailData.videoLink;
      document.body.classList.add('body-hidden');
      document.getElementById("gp-detail").style.zIndex = 101;
    },
    closeGameVideoModal() {
      this.flag_modal_video = false;
      this.current_game_vidio = "";
      document.body.classList.remove('body-hidden');
      document.getElementById("gp-detail").style.zIndex = 99;
    },
    openOutLink(_url) {
      window.open(_url);
    }
  },
};
</script>

<style scoped lang="scss">
.gp-modal {
  background: rgba(0, 0, 0, 1);
}

.button-text .button__label span {
  font-size: 16px;
}

.detail-wrap-1 .game__header {
  height: 100vh;
  position: relative;
}

.detail-wrap-2 .game__header {
  height: 90vh;
  position: relative;
}

@media (min-width: 0em) and (max-width: 800px) {
  .game__header {
    height: 100vh !important;
  }
}

.gp-modal {
  overflow: auto;
}

.content__row--game-modal iframe {
  width: 100vw;
  height: 100vh;
}

/* commen */
.detail {
  min-height: 100vh;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #1d1d1b;
}

.dot-overlay {
  position: absolute;
  z-index: 2;
  background-image: url(../assets/pattern.png);
  background-repeat: repeat !important;
  background-attachment: scroll;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
}

.game__header__image {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100%;
}

.game__header__sizzler {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
}

@media (min-width: 0em) and (max-width: 800px) {
  .game__header__sizzler {
    display: none;
  }
}

.game__header__sizzler video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 177.77777778vh;
  min-width: 100%;
  min-height: 56.25vw;
}

.game__header__sizzler_bg {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100%;
}

.game__header .game__logo {
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: 90px;
  margin-left: -17%;
  width: 34%;
}

.game__header .game__cta {
  font-family: Roboto Condensed, sans-serif;
  font-weight: 700;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  bottom: 40px;
  right: 0;
  vertical-align: middle;
}

@media (min-width: 1920px) {
  .game__header .game__cta {
    bottom: 100px;
  }
}

@media (min-width: 0em) and (max-width: 800px) {
  .game__header .game__cta {
    left: 22px;
    bottom: 90px;
  }

  .game__header .game__cta>button {
    display: inline-block;
    min-width: 100px;
    border-right: solid;
    border-width: thin;
    text-align: center;
    padding: 12px;
    margin-right: 6px;
  }

  .game__header .game__cta>img {
    display: none;
  }
}

.game__header .game__cta__button {
  text-align: right;
  margin: 4px -1px 0 0;
}

.game__header .game__cta__button .button .button__label {
  min-width: 187px;
  text-align: left;
  padding-left: 22px;
  padding-right: 24px;
}

.game__header .game__cta__button.game__cta__button--official-site {
  text-align: left;
  padding-left: 22px;
  margin-top: 26px;
  font-size: 1.4em;
}

@media (min-width: 1920px) {
  .game__header .game__cta__button.game__cta__button--official-site {
    font-size: 18px;
  }
}

.game__header .game__cta__button {
  text-align: right;
  margin: 4px -1px 0 0;
}

@keyframes buy-now-hover {
  30% {
    transform: translateX(-8px);
  }

  to {
    transform: translateX(0);
  }
}

.button.button--transparent .button__background {
  border: thin solid #fff;
  background-color: transparent;
}

.button.button--transparent .button__label {
  color: #fff;
}

// .button.button--transparent .button__label.button__label--hover {
//     color: #000
// }

.button.button--red .button__background {
  background-color: red;
  border: thin solid red;
}

.button.button--red .button__label {
  color: #fff;
}

.button.button--red .button__label.button__label--hover {
  color: red;
}

.button.button--red .button__slide-in {
  background-color: #fff;
}

.button .button__label.button__label--default {
  transform: translateX(0);
  opacity: 1;
}

.button:hover .button__label.button__label--hover {
  transform: translateX(0);
  opacity: 1;
}

.button:hover .button__label.button__label--default {
  transform: translateX(20%);
  opacity: 0;
}

.button .button__label.button__label--hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-20%);
  opacity: 0;
}

.button .button__label--hover {
  color: red;
}

.game__header .game__tile-shadow {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 8px;
  width: 100%;
  background-image: linear-gradient(180deg, transparent, #000);
}

/* mobile */
.game-mobile__info {
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 0;
  width: 100%;
}

.game-mobile__info .game-mobile__logo {
  display: block;
  width: 80%;
  margin: 0 auto 12px;
}

.game-mobile__info .game-mobile__cta {
  display: block;
  font-family: Roboto Condensed, sans-serif;
  font-weight: 700;
  text-align: center;
  background-color: red;
  color: #fff;
  font-size: 18px;
  padding: 1em;
}

.game-mobile__info .game-mobile__links-container {
  padding: 0 15px 2em;
}

@media (min-width: 0em) and (max-width: 800px) {
  .game-mobile__info .game-mobile__links-container {
    padding-bottom: 1em;
  }
}

.game-mobile__info .game-mobile__links {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.game-mobile__info .game-mobile__link {
  -ms-flex-positive: 1;
  flex-grow: 1;
  min-width: 30%;
  padding: 5px;
}

.button--block {
  display: block;
}

.button--block .button__label {
  min-width: auto;
}

/* modal */
.content__row--game-modal {
  display: table;
  width: 100%;
  height: 100%
}

.game__modal__text {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  height: 100%;
  padding: 68px 20px
}

.game__modal__text>div {
  width: 80%;
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text {
    padding: 0;
    width: 100vw
  }

  .game__modal__text>div {
    width: 90%;
    margin: 56px auto 0
  }
}

.game__modal__fob {
  vertical-align: top;
  width: 40%;
  max-width: 400px;
  float: left
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__fob {
    display: block;
    width: auto;
    margin: 0 auto;
    float: none
  }
}

.game__modal__fob>img {
  padding-right: 15%;
  width: 100%
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__fob>img {
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 10%
  }
}

.game__modal__text-description {
  overflow: hidden;
  margin-bottom: 10%
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-description {
    width: 100%
  }
}

.game__modal__text-description>img {
  margin-bottom: 12px;
  max-width: 300px
}

.game__modal__text-description>p {
  color: #cacaca
}

.game__modal__text-description .disclaimer {
  color: #515151
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-description>img {
    width: 70%
  }

  .game__modal__text-description>h1 {
    font-size: 2.7em
  }

  .game__modal__text-description>p {
    line-height: 1.1
  }
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-stats {
    margin-top: 45px
  }
}

.content__row--game-modal {
  display: table;
  width: 100%;
  height: 100%
}

.game__stat {
  display: table-cell;
  vertical-align: top;
  color: #7a7979;
  min-width: 100px;
}

.game__stat .release-rating {
  margin-top: 1em
}

@media (min-width: 0em) and (max-width:800px) {
  .game__stat .release-rating {
    margin-top: 0
  }
}

@media (min-width: 801px) {
  .game__stat:nth-child(2) {
    padding: 0 2em
  }

  .game__stat .button .button__label {
    min-width: 0;
    padding: .5em 1em
  }
}

@media (min-width: 0em) and (max-width:800px) {
  .game__stat:first-child {
    width: 60%;
    padding-right: 2em
  }
}

.stat__title {
  color: #cacaca;
  margin-top: 1em
}

@media (min-width: 0em) and (max-width:800px) {
  .stat__title {
    margin-top: 0
  }
}

.release-dates {
  font-size: 1em
}

.release-dates p {
  margin-top: 1em
}

.release-dates p:nth-child(2) {
  margin-top: 0px !important;
}

.release-dates li {
  color: #cacaca;
  padding-bottom: 6px
}

@media (min-width: 0em) and (max-width:800px) {
  .release-dates {
    font-size: .8em
  }

  .release-dates li {
    padding-bottom: 0
  }
}

.game__modal__link {
  display: block
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__link {
    font-size: 1.45em
  }
}

.game__modal__cta-btn {
  margin-top: 1em
}

.game__mobile__info--right {
  text-align: right;
  margin-bottom: 35px
}



.game__body {
  width: 100%
}

.featured__layout {
  position: relative;
  width: 100%
}

.featured__media--video {
  cursor: pointer;
}

.featured__media {
  position: absolute;
  overflow: hidden;
}

@media (min-width: 0em) and (max-width: 800px) {
  .featured__media {
    position: relative;
    top: 0 !important;
    left: 0 !important;
    width: 100%;
  }
}

@media (min-width: 1920px) {
  .featured__media--video .btn--hover {
    background-image: url(../assets/sprite-lfd.png);
    background-position: 0 -61.5px;
    background-size: 251.5px 233.5px;
    width: 56.5px;
    height: 56.5px;
  }
}

.featured__media--video .btn--hover {
  background-image: url(../assets/sprite-ui.png);
  background-position: 0 -50px;
  background-size: 302.5px 276.5px;
  width: 45px;
  height: 45px;
}

.featured__media--play-btn {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 50%;
  width: 50px;
  transform: translate(-25px, -25px);
}

.btn--hover,
.hover-enabled #game_container .featured__media--video:hover .btn--non-hover {
  display: none;
}

.featured__media--video .btn--non-hover {
  background-image: url(../assets/sprite-ui.png);
  background-position: -50px -50px;
  background-size: 302.5px 276.5px;
  width: 45px;
  height: 45px;
}

.tile__text {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 22px;
  color: #fff;
}

.featured__media--inner {
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.tile__bg {
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .3s;
}

.featured__media--display-title {
  opacity: 0;
}

.featured__media--display-title {
  font-family: Roboto Condensed, sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  z-index: 2;
  transition: opacity .2s;
}

.tile__text>* {
  position: relative;
  z-index: 2;
}

.tile__text:after {
  transition: opacity .3s;
  display: block;
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 101%;
  height: 100%;
  background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, .5) 50%);
}

.featured__media .tile__text:after {
  background-image: none;
}

@media (min-width: 0em) and (max-width: 800px) {
  .featured__media:before {
    display: block;
    content: "";
  }
}

@media (min-width: 0em) and (max-width: 800px) {
  .featured__layout--4 .featured__media:nth-child(2n):before {
    padding-bottom: 94%;
  }
}

@media (min-width: 0em) and (max-width: 800px) {
  .featured__layout--4 .featured__media:nth-child(1n):before {
    padding-bottom: 35%;
  }
}

.featured__media:hover .tile__text:after {
  transition: opacity .3s;
  display: block;
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 101%;
  height: 100%;
  background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, .5) 50%)
}

.featured__media:hover .featured__media--display-title {
  opacity: 1;
  color: #fff !important;
}

.tile:hover {
  background-color: #cc0001;
}

.featured__media--video:hover .btn--hover {
  display: block;
}

.btn--hover,
.featured__media--video:hover .btn--non-hover {
  display: none;
}

.tile:hover .tile__text:after {
  opacity: 0;
}

.tile:hover .tile__bg,
.tile:hover .tile__bg {
  opacity: .2;
}

.tile:hover .tile__bg {
  transform: scale(1.1);
  filter: grayscale(50%);
}

@media (min-width: 1920px) {
  .featured__media--video .btn--non-hover {
    background-image: url(../assets/sprite-lfd.png);
    background-position: -90.5px 0;
    background-size: 251.5px 233.5px;
    width: 56.5px;
    height: 56.5px;
  }

  .featured__media--video .btn--hover {
    background-image: url(../assets/sprite-lfd.png);
    background-position: 0 -61.5px;
    background-size: 251.5px 233.5px;
    width: 56.5px;
    height: 56.5px;
  }
}

//featured
.featured__layout--3 .featured__media:nth-child(1n) {
  top: 0;
  left: 0;
  height: 100%;
  width: 47%
}

.no-social-widget .featured__layout--3 .featured__media:nth-child(1n) {
  width: 58.75%
}

@media (min-width: 0em) and (max-width:800px) {
  .featured__layout--3 .featured__media:nth-child(1n):before {
    padding-bottom: 87%
  }
}

.featured__layout--3 .featured__social {
  top: 0;
  left: 47%;
  width: 20%;
  height: 100%
}

.no-social-widget .featured__layout--3 .featured__social {
  display: none
}

.featured__layout--3 .featured__media:nth-child(2n) {
  top: 0;
  left: 67%;
  height: 43%;
  width: 33%
}

.no-social-widget .featured__layout--3 .featured__media:nth-child(2n) {
  width: 41.25%;
  left: 58.75%
}

@media (min-width: 0em) and (max-width:800px) {
  .featured__layout--3 .featured__media:nth-child(2n):before {
    padding-bottom: 53%
  }
}

.featured__layout--3 .featured__media:nth-child(3n) {
  top: 43%;
  left: 67%;
  height: 57%;
  width: 33%
}

.no-social-widget .featured__layout--3 .featured__media:nth-child(3n) {
  width: 41.25%;
  left: 58.75%
}

@media (min-width: 0em) and (max-width:800px) {
  .featured__layout--3 .featured__media:nth-child(3n):before {
    padding-bottom: 71%
  }
}

.featured__layout--2 .featured__media:nth-child(1n) {
  top: 0;
  left: 0;
  height: 100%;
  width: 40%
}

.no-social-widget .featured__layout--2 .featured__media:nth-child(1n) {
  width: 50%
}

@media (min-width: 0em) and (max-width:800px) {
  .featured__layout--2 .featured__media:nth-child(1n):before {
    padding-bottom: 102.4%
  }
}

.featured__layout--2 .featured__media:nth-child(2n) {
  top: 0;
  left: 40%;
  height: 100%;
  width: 40%
}

.no-social-widget .featured__layout--2 .featured__media:nth-child(2n) {
  left: 50%;
  width: 50%
}

@media (min-width: 0em) and (max-width:800px) {
  .featured__layout--2 .featured__media:nth-child(2n):before {
    padding-bottom: 102.4%
  }
}

.featured__layout--2 .featured__social {
  top: 0;
  left: 80%;
  width: 20%;
  height: 100%
}

.no-social-widget .featured__layout--2 .featured__social {
  display: none
}</style>


// WEBPACK FOOTER //
// src/views/Detail.vue